module.exports = __webpack_public_path__ + "img/cool-text.dc4be3a6.svg";